module.exports = __webpack_public_path__ + "static/media/LogoPurple.eb0a8527.svg";